const RAW_API_BASE_URL =
  (process.env.REACT_APP_API_BASE_URL || "https://api.dev.gerify.com.br").replace(
    /\/+$/,
    ""
  );

export const API_BASE_URL = RAW_API_BASE_URL;

export const API_ENDPOINTS = {
  login: "/v1/app/auth/login",
  logout: "/v1/app/auth/logout",
  register: "/v1/app/auth/register",
  activate: "/v1/app/auth/activate",
  profile: "/v1/app/profile",
  preferences: "/v1/app/preferences",
  preferencesUpdate: "/v1/app/preferences/update",
  userList: "/v1/app/user/list",
  userCreate: "/v1/app/user/create",
  permissionsList: "/v1/app/permissions",
  roleList: "/v1/app/role/list",
  roleGet: "/v1/app/role",
  roleCreate: "/v1/app/role/create",
  rolePermissionsUpdate: "/v1/app/role/permissions",
  twoFactorGenerate: "/v1/app/twofactor/generate",
  twoFactorValidate: "/v1/app/twofactor/validate",
  twoFactorDisable: "/v1/app/twofactor/disable",
  twoFactorVerify: "/v1/app/twofactor/verify",
} as const;

export function buildApiUrl(path: string) {
  return `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
